import React, { Component, Fragment } from 'react'
import { CaptionText } from 'app/common/typography'
import { FormattedMessage, injectIntl } from 'react-intl'
import {
    ButtonSmall,
    media,
    ResponsiveContainer,
    ResponsiveDesktop,
    ResponsiveMobile
} from 'app/assets/styles'
import styled from 'styled-components'
import { Cookie as CookieIcon } from 'app/assets/icons'
import { CookiesManagementModal } from 'app/common/cookies/management/modal'
import { colors } from 'shared/assets/styles'
import { deleteCookies } from 'shared/utils'
import type { IntlShape } from 'react-intl'

const { red, shadowBox } = colors

type Props = {
    cookiesConsentsDone: boolean,
    manageCookies: boolean,
    consentAllCookies: () => void,
    declineAllCookies: () => void,
    intl: IntlShape
}

type State = {
    showCookiesManagement: boolean
}

class CookiesConsent extends Component<Props, State> {
    state = {
        showCookiesManagement: false
    }

    toggleCookiesManagement = (e: SyntheticEvent<>) => {
        e.preventDefault()
        this.setState(prevState => ({
            showCookiesManagement: !prevState.showCookiesManagement
        }))
    }

    render() {
        const {
            consentAllCookies,
            declineAllCookies,
            manageCookies,
            cookiesConsentsDone,
            intl
        } = this.props
        const { showCookiesManagement } = this.state

        const acceptAll = (
            <FormattedMessage id="cookies.consent.accept.all">
                {(text: string) => (
                    <StyledButtonSmall
                        background={red}
                        color="white"
                        marginLeft
                        onClick={consentAllCookies}>
                        {text}
                    </StyledButtonSmall>
                )}
            </FormattedMessage>
        )
        const declineAll = (
            <FormattedMessage id="cookies.consent.decline.all">
                {(text: string) => (
                    <StyledButtonSmall
                        background="white"
                        color={red}
                        border={red}
                        onClick={() => {
                            deleteCookies()
                            declineAllCookies()
                        }}>
                        {text}
                    </StyledButtonSmall>
                )}
            </FormattedMessage>
        )
        const custom = (
            <FormattedMessage id="clickandcollect.cart.customize">
                {(text: string) => (
                    <StyledButtonSmall
                        background="white"
                        color={red}
                        border={red}
                        marginLeft
                        onClick={this.toggleCookiesManagement}>
                        {text}
                    </StyledButtonSmall>
                )}
            </FormattedMessage>
        )

        const cookiesManagementURL = intl.formatMessage({
            id: 'routes.cookies.management'
        })
        const currentURL = window.location.pathname

        return (
            <Fragment>
                {!cookiesConsentsDone &&
                    !showCookiesManagement &&
                    currentURL !== cookiesManagementURL && (
                        <CookiesConsentContainer>
                            <Popup>
                                <CookiesText>
                                    <CookieIcon />
                                    <Paragraph>
                                        <FormattedMessage id="cookies.consent.message" />
                                    </Paragraph>
                                </CookiesText>
                                <ResponsiveDesktop>
                                    <Row>
                                        {declineAll}
                                        {custom}
                                        {acceptAll}
                                    </Row>
                                </ResponsiveDesktop>
                                <ResponsiveMobile>
                                    <Column>
                                        {acceptAll}
                                        {declineAll}
                                        {custom}
                                    </Column>
                                </ResponsiveMobile>
                            </Popup>
                        </CookiesConsentContainer>
                    )}
                <CookiesManagementModal
                    open={
                        (!cookiesConsentsDone && showCookiesManagement) ||
                        manageCookies
                    }
                    cookiesConsentsDone={cookiesConsentsDone}
                    manageCookies={manageCookies}
                    handleClose={this.toggleCookiesManagement}
                />
            </Fragment>
        )
    }
}

const CookiesConsentContainer = styled.div`
    position: fixed;
    z-index: 10000;
    width: 100%;
    bottom: 0;
    padding: 10px 0;
    display: flex;
    align-items: center;
    justify-content: center;
`
const Popup = styled(ResponsiveContainer)`
    border-radius: 12px;
    background-color: white;
    box-shadow: 0 8px 16px 4px ${shadowBox};
    position: relative;
    margin: 0 10px;
    width: calc(100% - 20px);
    padding: 5px;

    ${media.medium`
        margin: 0 10px;
        width: auto;
        padding: 20px 120px;
    `};
`

const StyledButtonSmall = styled(ButtonSmall)`
    margin-bottom: 10px;
    width: 90%;
    ${media.medium`
        margin-top: 20px;
        ${props => props.marginLeft && `margin-left: 10px;`}
        margin-bottom: 0;
     `};
`

const CookiesText = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 0 5px;
    ${media.medium`
        flex-direction: row;
        padding: 0 10px;
    `};
`

const Row = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
`

const Column = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
`

const Paragraph = styled(CaptionText)`
    display: block;
    margin-right: 10px;
    margin: 10px 0;
    a {
        font-weight: bolder;
        text-decoration: underline;
    }
    ${media.medium`
        width: 540px;
        margin: 0;
        margin-left: 10px; 
    `};
`

const CookiesConsentComponent = injectIntl(CookiesConsent)
export { CookiesConsentComponent }
